import Pricing from '@standardnotes/pricing/dist/pricing.json'

const Sale = Pricing.Sale

export default Sale
